import { FlexBox, Icon, IconNames, Tooltip } from '@dixa/lib-shared-habla';
import {
  cloneElement,
  ComponentProps,
  type ReactElement,
  type ReactNode,
} from 'react';

import styles from './contactItem.module.scss';

export type ContactItemProps = {
  /** Icon to associate with the label */
  icon?: IconNames;
  /** Additional information shown next to the label, e.g. a Badge. */
  labelMeta?: ReactNode;
  /** The value, which can either be a simple string or a custom ReactElement. */
  value: ReactElement | string;
  /** The optional tooltip content to show when hovering the value. */
  valueTooltip?: string;
  /** The optional actions shown next to the value. */
  actions?: ReactNode;
  /** Custom props to pass to the wrapper FlexBox component. */
  flexBoxProps?: ComponentProps<typeof FlexBox>;
};

export const ContactItem = ({
  icon,
  labelMeta,
  value,
  valueTooltip,
  actions,
  flexBoxProps,
}: ContactItemProps): JSX.Element => {
  return (
    <FlexBox as="li" minWidth="0" {...flexBoxProps}>
      {icon && (
        <FlexBox alignItems="center" padding="0 200 0 0">
          <Icon name={icon} />
        </FlexBox>
      )}

      <FlexBox alignItems="center">
        <Tooltip content={valueTooltip} disabled={!valueTooltip} wrap="none">
          {typeof value === 'string' ? (
            <span className={styles.value}>{value}</span>
          ) : (
            cloneElement(value, { className: styles.value })
          )}
        </Tooltip>

        <FlexBox padding="0 0 0 100">{labelMeta}</FlexBox>

        <div className={styles.actions}>{actions}</div>
      </FlexBox>
    </FlexBox>
  );
};
